import styled from "styled-components"

export const StyledOnboardingOption = styled.div<{ $active: boolean }>`
  display: flex;
  padding: var(--spacing_l, 16px) var(--app_side_margin, 16px);
  align-items: center;
  gap: 16px;

  border-radius: 8px;
  background: var(--White-5, rgba(255, 255, 255, .049));
  cursor: default;
  width: 100%;

  border: ${({ $active }) =>
    $active ? "1px solid #14C9C9" : "1px solid transparent"};
`

export const OnboardingOptionTitle = styled.div`
  font-size: 18px;
  font-weight: 700;
  line-height: 140%;
`

export const OnboardingOptionDescription = styled.div`
  font-size: 14px;
  color: var(--White_40, rgba(255, 255, 255, 0.4));
`

export const ActiveList = styled.div`
  display: flex;
  padding-top: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--spacing_m, 12px);
  align-self: stretch;
`

export const OnboardingOptionIConWrapper = styled.div<{ $isSelected: boolean }>`
  display: flex;
  width: 60px;
  height: 60px;
  padding: 13px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background: ${({ $isSelected }) =>
    $isSelected
      ? "var(--Schemes-Surface-Container-Low, #F5F7F7)"
      : "var(--White_20, rgba(255, 255, 255, 0.20))"};
`
